// Notifiche (S7; tela, artboard 37): quello che è successo negli ultimi giorni e merita uno
// sguardo, ricavato dagli eventi del registro. Aprire la pagina le segna lette.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../../components/Icon';
import { PageHeader } from '../../components/PageHeader';
import { RelativeTime } from '../../components/RelativeTime';
import { SkeletonRow } from '../../components/Skeleton';
import { api } from '../../lib/api';
import type { Notice } from '../../lib/api';
import { noteUnread } from './unread';

export function Notifications() {
  const [items, setItems] = useState<Notice[] | null>(null);
  useEffect(() => {
    void api.notifications().then(
      (r) => {
        setItems(r.items);
        if (r.unread)
          void api.notificationsSeen().then(
            () => noteUnread(0),
            () => undefined,
          );
      },
      () => setItems([]),
    );
  }, []);
  return (
    <div className="page" style={{ display: 'grid', gap: 16 }}>
      <PageHeader
        title="Notifiche"
        subtitle="Gli ultimi 7 giorni: chi aspetta te, cosa si è concluso o fermato, cosa è arrivato da memo."
      />
      {items === null ? (
        <SkeletonRow />
      ) : items.length === 0 ? (
        <div className="t-caption faint">Niente di nuovo negli ultimi 7 giorni.</div>
      ) : (
        <section className="np-card">
          {items.map((n) => {
            const body = (
              <>
                <span style={{ color: `var(--${n.tone})`, display: 'inline-flex' }}>
                  <Icon name={n.icon} size={18} />
                </span>
                <span className={n.unread ? 't-strong' : 't-body'} style={{ flex: 1, minWidth: 0 }}>
                  {n.text}
                </span>
                <span className="t-caption faint">
                  <RelativeTime at={n.at} />
                </span>
              </>
            );
            // una sessione apre la sessione; uno strumento da ricollegare apre Strumenti
            const target = n.sessionId
              ? `/s/${n.sessionId}`
              : n.icon === 'plug'
                ? '/strumenti'
                : null;
            return target ? (
              <Link
                key={n.id}
                to={target}
                className="agent-card dash-row"
                data-unread={n.unread || undefined}
              >
                {body}
              </Link>
            ) : (
              <div key={n.id} className="dash-row">
                {body}
              </div>
            );
          })}
        </section>
      )}
    </div>
  );
}
